module.exports = __webpack_public_path__ + "static/media/filter_3.a11cc857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/filter_3.jpg
// module id = 1863
// module chunks = 0